import { useTranslation } from 'react-i18next';
import { routes } from 'routes/routes';
import { Link, Text } from 'ui';

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <Text>
      {import.meta.env.VITE_APP_LANDING_SUMMARY}{' '}
      {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases */}
      <a href={import.meta.env.VITE_APP_TERMS_URL} rel="noopener noreferrer" target="_blank">
        {t('Terms')}
      </a>{' '}
      &amp;{' '}
      <Link rel="noopener noreferrer" target="_blank" to={routes.privacyPolicy}>
        {t('Privacy Policy')}
      </Link>
    </Text>
  );
};
